import React, { useContext } from "react";
import { Formik } from "formik";
import { Link } from "react-router-dom";
import { login, getMe } from "../api/user";
import UserContext from "../contexts/UserContext";

const LoginScreen = () => {
  const user = useContext(UserContext);

  return (
    <>
      <h2>Login</h2>
      <Formik
        initialValues={{ userName: "", password: "" }}
        onSubmit={async (values, { setSubmitting }) => {
          const result = await login(values);

          result.ifSuccess(async loginResponse => {
            const profileResult = await getMe(loginResponse.access_token);

            profileResult.ifSuccess(profileResponse => {
              user.setProfile(profileResponse);
              user.setToken(loginResponse);
            });

            // TODO: error handling
            profileResult.ifError(error => setSubmitting(false));
          });

          // TODO: error handling
          result.ifError(error => setSubmitting(false));
        }}
      >
        {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <div>
              <label htmlFor="userName">Username</label>
              <input
                type="text"
                name="userName"
                id="userName"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.userName}
              />
            </div>
            <div>
              <label htmlFor="password">Password</label>
              <input
                type="password"
                name="password"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.password}
              />
            </div>
            <button type="submit" disabled={isSubmitting}>
              Submit
            </button>
          </form>
        )}
      </Formik>
      <Link to="/register">Sign up</Link>
    </>
  );
};

export default LoginScreen;
